import { JsonRPCService } from '@xengage/gw-portals-transport-js';
import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';

export default class AccountService {
    static accountExists(accountNumber, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayaccountAccount'),
            'accountExists',
            [accountNumber],
            additionalHeaders
        );
    }
}
